<template>
  <v-container fluid>
    <v-card width="100%" flat tile>
      <v-card-title class="body-heading-large mb-6">Settings</v-card-title>
      <v-card-text>
        <v-tabs v-model="activeTab">
          <v-tab v-for="item of tabItems" :key="item.index" @click="changeRoute(item.route)">
            <v-icon v-if="item.icon" left>{{ item.icon }}</v-icon>
            {{ item.title }}
          </v-tab>

          <v-tab-item v-for="item of tabItems" :key="item.index">
            <v-card flat>
              <v-card-text class="pa-0">
                <component :is="item.content"></component>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import AccountSettings from "./AccountSettings";
  import PaymentAndBillingSettings from "./PaymentAndBillingSettings";
  import NotificationSettings from "./NotificationSettings";

  export default {
    name: "SettingsInfoTabs",
    components: {
      AccountSettings,
      PaymentAndBillingSettings,
      NotificationSettings,
    },
    data() {
      return {};
    },
    computed: {
      user() {
        return this.$store.getters.userInfo;
      },
      activeTab: {
        get() {
          if (this.$route.name === "PaymentSettings") {
            return 1;
          }
          if (this.$route.name === "NotificationSettings") {
            return 2;
          }
          return 0;
        },
        set(newValue) {
          return newValue;
        },
      },
      tabItems() {
        if (this.user && this.user.role === "parent") {
          return [
            {
              index: 0,
              title: "Account",
              icon: "",
              content: AccountSettings,
              route: "AccountSettings",
            },
            {
              index: 1,
              title: "Payment & Billing",
              icon: "",
              content: PaymentAndBillingSettings,
              route: "PaymentSettings",
            },
            {
              index: 2,
              title: "Notification",
              icon: "",
              content: NotificationSettings,
              route: "NotificationSettings",
            },
          ];
        } else {
          return [
            {
              index: 0,
              title: "Account",
              icon: "",
              content: AccountSettings,
              route: "AccountSettings",
            },
          ];
        }
      },
    },
    methods: {
      changeRoute(route) {
        if (!this.$validator.isEmpty(route) && this.$route.name !== route) {
          this.$router.push({ name: route });
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/GeneralSettings/SettingsInfoTabs.vue